<template>
  <b-form-group
    label="Teklif Tarihi"
    label-for="odate"
  >
    <validation-provider
      #default="{ errors }"
      name="Teklif Tarihi"
      rules="required"
    >
      <b-form-datepicker
        id="odate"
        v-model="dataItem.odate"
        v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
        locale="tr"
        start-weekday="1"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'OfferDate',
  components: {
    BFormGroup,
    BFormDatepicker,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['offers/dataItem']
    },
  },
  created() {
    localize('tr')
  },
  mounted() {
    this.setOfferDate()
  },
  methods: {
    setOfferDate() {
      if (!this.dataItem.odate) {
        this.dataItem.odate = this.moment().format('YYYY-MM-DD')
      }
    },
  },
}
</script>
